module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/lemons_6ab5a7.jpg";